import React, { Component } from 'react'
import Auth from '../../Modules/Auth'
import axios from 'axios'
import './OwnerDashboard.scss'
import TopIntro from '../../Components/Dashboard/OwnerTopIntro'
import ScheduleList from '../../Components/Dashboard/OwnerScheduleList'
import AlarmList from '../../Components/Dashboard/OwnerAlarmList'
import LiveVideo from '../../Components/Dashboard/OwnerLiveVideo'
import ReportList from '../../Components/Dashboard/OwnerReportList'
import DemandList from '../../Components/Dashboard/OwnerDemandList'
import TodoList from '../../Components/Dashboard/OwnerTodoList'
import OwnerComplete from '../../Components/Dashboard/OwnerComplete'
import { withCookies, Cookies } from 'react-cookie'
import HeaderMenu from '../../Components/Commons/HeaderMenu'
import HeaderMenuWhite from '../../Components/Commons/HeaderMenuWhite'

class OwnerDashboard extends Component {
    constructor(props) {
        super(props)

        this.state = {
            project: null,
            user: null,
        }
    }

    UNSAFE_componentWillMount() {
        this.loadUser()
        this.loadProject()
    }

    loadUser = () => {
        axios
            .get(`${BACKEND_HOST}/auth/me`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                this.setState({ user: res.data })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    loadProject = () => {
        const { cookies } = this.props
        axios
            .get(`${BACKEND_HOST}/projects/${cookies.get('project')}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res.data)

                this.setState({
                    project: res.data,
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    render() {
        // let banner
        // if (this.state.user.group !== 'CLIENT') {
        //     banner = <Banner width="1042px" />
        // } else {
        //     banner = null
        // }
        if (this.state.user === null) {
            return <></>
        }
        if (this.state.project) {
            if (this.state.project.status === 'FINISH') {
                return (
                    <div>
                        <HeaderMenuWhite />
                        <OwnerComplete project={this.state.project} />
                    </div>
                )
            } else {
                return (
                    <div>
                        <HeaderMenu />
                        <div className="section_wrap section_wrap_menu">
                            <div className="owner_dashboard_wrap">
                                <TopIntro project={this.state.project} />
                                <div className="box_content_wrap">
                                    {/* {banner} */}
                                    <div className="common_wrap">
                                        <AlarmList user={this.state.user} history={this.props.history} />
                                        <ScheduleList />
                                    </div>
                                </div>
                                <div className="video_report_wrap">
                                    <LiveVideo project={this.state.project} />
                                    <ReportList />
                                </div>
                                <DemandList />
                                <TodoList />
                            </div>
                        </div>
                    </div>
                )
            }
        }
        return (
            <div>
                <HeaderMenu />
                <div className="section_wrap" />
            </div>
        )
    }
}

export default withCookies(OwnerDashboard)



// WEBPACK FOOTER //
// ./Src/Containers/Dashboard/OwnerDashboard.js